module.exports = __webpack_public_path__ + "img/mastercard-white.3ff2cb33.svg";